module.exports = __webpack_public_path__ + "img/3.5d6cc3bc.jpg";